module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Range-hood-4ec8772ecb2fbc2a49f9230b840559df.svg";